import http from './http.service';

class VehicleGroupService {
    constructor() {
        if (VehicleGroupService.instance) {
            return VehicleGroupService.instance;
        }

        VehicleGroupService.instance = this;
    }

    groups() {
        return http.get('/vehicle-groups').then(res => res.data);
    }
    store(data) {
        return http.post('/vehicle-groups/store', data).then(res => res.data);
    }
    update(groupId, data) {
        return http.put(`/vehicle-groups/${groupId}/update`, data).then(res => res.data);
    }
    reorderVehicles(vehicles) {
        return http.put('/vehicle-groups/reorder-vehicles', vehicles).then(res => res.data);
    }
    reorder(groups) {
        return http.put('/vehicle-groups/reorder', groups).then(res => res.data);
    }
    destroy(groupId) {
        return http.delete(`/vehicle-groups/${groupId}/destroy`).then(res => res.data);
    }
    removeFromGroup(groupId, vehicleId) {
        return http.delete(`/vehicle-groups/${groupId}/vehicles/${vehicleId}/remove`).then(res => res.data);
    }
}

export default new VehicleGroupService();
